<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M24 25a10.5 10.5 0 1110.5-10.5A10.51 10.51 0 0124 25zm0-18a7.5 7.5 0 107.5 7.5A7.5 7.5 0 0024 7zM39 44H9a2 2 0 01-2-2V31.36a2 2 0 011.37-1.9l7.16-2.39a2 2 0 011.58.14 14.41 14.41 0 0013.77 0 2 2 0 011.6-.15l7.15 2.39A2 2 0 0141 31.36V42a2 2 0 01-2 2zm-29-3h28v-8.92l-6.06-2a17.5 17.5 0 01-15.88 0l-6.06 2zm21.52-11.08zm-15 0z"/></svg>